import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

// Read-only capability list metadata (t1 reads capabilities authored in t6). Backs the Capability
// picklist used to grant a capability to a share on the Visibility tab.
class CapabilityEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "Capability";
        this.defaultCacheSize = 1000;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", false, true, true, false, null, null, null, 36, null, null, "UUID", null, false,
        );
        this.attributes["Name"] = new EnterpriseComponentAttributeMetadata(
            "Name", false, false, true, false, null, null, null, 100, null, null, "String", null, false,
        );
        this.attributes["Description"] = new EnterpriseComponentAttributeMetadata(
            "Description", false, false, false, false, null, null, null, 1000, null, null, "String", null, false,
        );
        this.attributes["ObjectType"] = new EnterpriseComponentAttributeMetadata(
            "ObjectType", false, false, false, false, null, null, null, 100, null, null, "String", null, false,
        );
        this.attributes["CreatedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "CreatedDatetime", false, true, false, false, null, null, null, null, null, null, "Datetime", null, false,
        );
    }
}

export default CapabilityEnterpriseComponentMetadata;
